"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Google16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M7.99973 0.000539093C9.90041 -0.0219541 11.7392 0.660178 13.1612 1.90802L13.3525 2.08167L11.0685 4.36563C10.2425 3.57786 9.14024 3.1487 7.99973 3.16633C5.91272 3.16633 4.14022 4.57433 3.50824 6.47028C3.19892 7.38739 3.17513 8.37463 3.43686 9.30253L3.50824 9.5332C4.1461 11.4262 5.91566 12.8342 8.00267 12.8342C8.99847 12.8342 9.86402 12.5988 10.5554 12.1788L10.7216 12.0712C11.5091 11.5487 12.0634 10.7143 12.2796 9.79762L12.3207 9.6H7.99973V6.4H15.5453C15.6394 6.93498 15.6835 7.64019 15.6835 8.18399C15.6835 10.5242 14.879 12.5166 13.4714 13.9051L13.3008 14.0664C12.0345 15.2384 10.3146 15.9374 8.27922 15.996L7.99973 16C5.05905 16 2.36287 14.3885 0.967376 11.8165L0.850973 11.5938L0.733747 11.3501C-0.244582 9.22532 -0.244582 6.77816 0.733747 4.65342L0.850973 4.40972L0.967376 4.18669C2.36287 1.61202 5.05905 0.000539093 7.99973 0.000539093Z", fill: "#131416" }));
}
function Google16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Google16Svg, Object.assign({}, svgProps)));
}
exports.default = Google16;
//# sourceMappingURL=Google16.js.map